import { initStorageInstance } from './index'
import {
  MALFUNCTION_REPAIR_ADDRESS_INFO_KEY,
  MALFUNCTION_REPAIR_ORDER_FORM_DATA_KEY,
  MALFUNCTION_REPAIR_SELECTED_DEVICES_KEY,
  MALFUNCTION_REPAIR_ORDER_FORM_FIRST_DATA_KEY,
  MALFUNCTION_REPAIR_FLY_LOGS_KEY,
  MALFUNCTION_REPAIR_SELECTED_FLY_LOG_KEY,
  MALFUNCTION_REPAIR_ORDER_DETAIL_KEY,
  DEVICETYPE,
} from './constant'

// export const MalfunctionRepairScanListStorage
export const MalfunctionRepairSelectedDevicesStorage = initStorageInstance(
  MALFUNCTION_REPAIR_SELECTED_DEVICES_KEY,
  {
    type: 'sessionStorage',
  }
)

export const MalfunctionRepairAddressInfoStorage = initStorageInstance(
  MALFUNCTION_REPAIR_ADDRESS_INFO_KEY,
  {
    type: 'localStorage',
    verifyMobile: true,
  }
)
export const MalfunctionRepairOrderFormFirstDataStorage = initStorageInstance(
  MALFUNCTION_REPAIR_ORDER_FORM_FIRST_DATA_KEY,
  {
    type: 'sessionStorage',
  }
)
export const MalfunctionRepairOrderFormDataStorage = initStorageInstance(
  MALFUNCTION_REPAIR_ORDER_FORM_DATA_KEY,
  {
    type: 'sessionStorage',
  }
)

export const MalfunctionRepairFlyLogsStorage = initStorageInstance(
  MALFUNCTION_REPAIR_FLY_LOGS_KEY,
  {
    type: 'sessionStorage',
  }
)

export const MalfunctionRepairSelectedFlyLogStorage = initStorageInstance(
  MALFUNCTION_REPAIR_SELECTED_FLY_LOG_KEY,
  {
    type: 'sessionStorage',
  }
)

export const MalfunctionRepairOrderDetailStorage = initStorageInstance(
  MALFUNCTION_REPAIR_ORDER_DETAIL_KEY,
  {
    type: 'sessionStorage',
  }
)

export const MalfunctionRepairDeviceTypeStorage = initStorageInstance(DEVICETYPE, {
  type: 'sessionStorage',
})
